import React from 'react'
import BannerHomeMobile from './banner_home_mobile'
import BannerHomeDesktop from './banner_home_desktop'

const BannerHome = ({ is_mobile, sponsoredPost }) => {
  const props = {
    is_mobile: is_mobile || false,
    sponsoredPost: sponsoredPost || [],
  }

  if (props.is_mobile) {
    return <BannerHomeMobile {...props} />
  } else {
    return <BannerHomeDesktop {...props} />
  }
}

export default BannerHome
